"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationSchema = exports.TimestampSort = exports.TimestampSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const temporal_1 = require("../conversions/temporal");
const primitives_1 = require("./primitives");
// Assume that no order before year 2000 (so timestamps like 0 are invalid, and as are second since epoch)
const MIN_TIMESTAMP = (0, temporal_1.dateToTimestamp)(new Date("2000/01/01 00:00:00 UTC"));
// Provide a maximum just so if people send nano time, its an error
const MAX_TIMESTAMP = (0, temporal_1.dateToTimestamp)(new Date("2100/01/01 00:00:00 UTC"));
exports.TimestampSchema = typebox_1.Type.Integer({
    minimum: MIN_TIMESTAMP,
    maximum: MAX_TIMESTAMP,
    examples: [(0, temporal_1.dateToTimestamp)(new Date("2021/08/01 09:00:00"))],
    title: "Timestamp",
    description: "Timestamp in milliseconds since Unix Epoch",
});
/** Sorting by timestamp is common enough to have a common type  */
exports.TimestampSort = (0, primitives_1.StringUnion)(["timestamp"]);
exports.DurationSchema = typebox_1.Type.Integer({
    minimum: 0,
    maximum: MAX_TIMESTAMP - MIN_TIMESTAMP,
    examples: [3600000],
    title: "Duration",
    description: "Duration in milliseconds",
});
